import axios from 'axios';

// Cria uma instância do axios com uma baseURL configurada
// Isso evita ter que repetir o endereço base em todas as chamadas
// Usa a variável de ambiente para definir a URL base
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://vestibula.onrender.com',
  timeout: 30000, // 30 segundos de timeout para requisições mais pesadas
  withCredentials: true, // Permite o envio de cookies/credenciais, se necessário
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0'
  }
});

// Add a request interceptor to include the auth token automatically
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
      const parsedUserInfo = JSON.parse(userInfo);
      const token = parsedUserInfo.token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 401 unauthorized responses
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const hasUser = !!localStorage.getItem('userInfo');

    // Only handle 401 errors for authenticated users (not during login)
    if (error.response && error.response.status === 401 && hasUser) {
      // Remove user info from localStorage
      localStorage.removeItem('userInfo');
      localStorage.removeItem('currentPage');
      // Dispatch a custom event to notify the app about the logout
      window.dispatchEvent(new Event('userLoggedOut'));
    }
    return Promise.reject(error);
  }
);

export default api;